import { Constants } from 'src/app/helper/constants';

export const GET_SITE_REQUEST_APPROVALS = Constants.HSE_BASE_URL + '/siterequests';
export const POST_SITE_REQUEST_APPROVALS = GET_SITE_REQUEST_APPROVALS + '/updatestatus';
